import React from 'react'

import { Helmet } from 'react-helmet'

import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>
          FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
      </Helmet>
      <div className="home-home">
        <div className="home-frame189">
          <div className="home-frame188">
            <div className="home-frame">
              <div className="home-frame195">
                <div className="home-frame162">
                  <img
                    alt="VectorI261"
                    src="/external/vectori261-h4i9.svg"
                    className="home-vector10"
                  />
                  <span className="home-text10">futureheirs</span>
                </div>
                <div className="home-frame81">
                  <div className="home-frame6">
                    <span className="home-text11">Home</span>
                  </div>
                  <div className="home-frame7">
                    <span className="home-text12">About Us</span>
                  </div>
                  <div className="home-frame82">
                    <span className="home-text13">Contact Us</span>
                  </div>
                  <div className="home-frame9">
                    <span className="home-text14">Blog</span>
                  </div>
                </div>
                <div className="home-component41">
                  <span className="home-text15">Join Us</span>
                </div>
              </div>
              <div className="home-frame194">
                <div className="home-frame133">
                  <div className="home-group35">
                    <span className="home-text16">
                      Raising Tomorrow&apos;s Leaders through Faith Innovation
                    </span>
                    <div className="home-group36">
                      <span className="home-text17">and</span>
                      <span className="home-text18">and</span>
                      <span className="home-text19">and</span>
                    </div>
                  </div>
                  <span className="home-text20">
                    Empowering children and young adults to discover their
                    God-given potential through education, technology, and
                    purpose-driven learning.
                  </span>
                </div>
                <div className="home-cta1">
                  <div className="home-component11">
                    <span className="home-text21">Join Our Mission</span>
                    <img
                      alt="Frame5I142"
                      src="/external/frame5i142-9jw.svg"
                      className="home-frame5"
                    />
                  </div>
                  <div className="home-learn-about-our-programs">
                    <span className="home-text22">
                      Learn About Our Programs
                    </span>
                  </div>
                </div>
              </div>
              <div className="home-frame1310">
                <span className="home-text23">Scroll down</span>
                <div className="home-frame31">
                  <div className="home-vuesaxlineararrowdown1">
                    <div className="home-vuesaxlineararrowdown2">
                      <div className="home-arrowdown1">
                        <img
                          alt="Vector1502"
                          src="/external/vector1502-fia.svg"
                          className="home-vector11"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="home-vuesaxlineararrowdown3">
                    <div className="home-vuesaxlineararrowdown4">
                      <div className="home-arrowdown2">
                        <img
                          alt="Vector1502"
                          src="/external/vector1502-169f.svg"
                          className="home-vector12"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="home-vuesaxlineararrowdown5">
                    <div className="home-vuesaxlineararrowdown6">
                      <div className="home-arrowdown3">
                        <img
                          alt="Vector1502"
                          src="/external/vector1502-zg0g.svg"
                          className="home-vector13"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Rectangle41492"
              src="/external/rectangle41492-2qhr.svg"
              className="home-rectangle41"
            />
            <div className="home-frame186">
              <div className="home-frame145">
                <div className="home-frame144">
                  <img
                    alt="Rectangle41422"
                    src="/external/rectangle41422-yx6s-300h.png"
                    className="home-rectangle42"
                  />
                  <div className="home-frame171">
                    <div className="home-frame21">
                      <span className="home-text24">Who We Are</span>
                    </div>
                    <span className="home-text25">
                      FutureHeirs is a faith-based non-profit organization
                      founded on the belief that every child deserves the
                      opportunity to flourish in their unique calling. We bridge
                      the gap between quality education and accessibility,
                      preparing young minds to lead with integrity, innovate
                      with purpose, and serve with compassion.
                    </span>
                  </div>
                </div>
                <div className="home-frame143">
                  <div className="home-frame16">
                    <div className="home-frame191">
                      <div className="home-group391">
                        <img
                          alt="Ellipse11523"
                          src="/external/ellipse11523-aiu-200h.png"
                          className="home-ellipse11"
                        />
                        <img
                          alt="puzzlepiece6svgrepocom11523"
                          src="/external/puzzlepiece6svgrepocom11523-ysc8.svg"
                          className="home-puzzlepiece6svgrepocom1"
                        />
                      </div>
                      <span className="home-text26">Our Purpose</span>
                    </div>
                    <span className="home-text27">
                      FutureHeirs exists to bridge the gap between quality
                      education and accessibility, ensuring every child
                      flourishes in their unique calling.
                    </span>
                  </div>
                  <div className="home-frame14">
                    <div className="home-frame18">
                      <div className="home-group381">
                        <img
                          alt="Ellipse11422"
                          src="/external/ellipse11422-d75n-200h.png"
                          className="home-ellipse12"
                        />
                        <img
                          alt="book2svgrepocom11422"
                          src="/external/book2svgrepocom11422-fchj.svg"
                          className="home-book2svgrepocom1"
                        />
                      </div>
                      <span className="home-text28">Our Vision</span>
                    </div>
                    <span className="home-text29">
                      A world where every child receives transformative
                      education, blending faith and innovation to inspire future
                      leaders who drive positive change.
                    </span>
                  </div>
                  <div className="home-frame175">
                    <div className="home-frame192">
                      <div className="home-group382">
                        <img
                          alt="Ellipse11523"
                          src="/external/ellipse11523-jxax-200h.png"
                          className="home-ellipse13"
                        />
                        <img
                          alt="targetsvgrepocom11523"
                          src="/external/targetsvgrepocom11523-zenm.svg"
                          className="home-targetsvgrepocom1"
                        />
                      </div>
                      <span className="home-text30">Our Mission</span>
                    </div>
                    <span className="home-text31">
                      Empowering future leaders through Christ-centered
                      education, tech literacy, and character development to
                      fulfill their God-given potential.
                    </span>
                  </div>
                </div>
              </div>
              <div className="home-component5">
                <div className="home-frame140">
                  <span className="home-text32">Our Programs</span>
                  <div className="home-frame131">
                    <img
                      alt="Frame130I253"
                      src="/external/frame130i253-45mu.svg"
                      className="home-frame130"
                    />
                    <img
                      alt="Frame109I253"
                      src="/external/frame109i253-tu5.svg"
                      className="home-frame1091"
                    />
                  </div>
                </div>
                <div className="home-frame139">
                  <div className="home-frame135">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-ar9e-200h.png"
                      className="home-rectangle31"
                    />
                    <div className="home-frame1341">
                      <span className="home-text33">
                        Online Learning Academy
                      </span>
                      <span className="home-text34">
                        Our digital platform makes quality, faith-integrated
                        education...
                      </span>
                    </div>
                    <div className="home-component42">
                      <span className="home-text35">Learn more</span>
                    </div>
                  </div>
                  <div className="home-frame138">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-3f9k-200h.png"
                      className="home-rectangle32"
                    />
                    <div className="home-frame1342">
                      <span className="home-text36">
                        Tech Innovation Centers
                      </span>
                      <span className="home-text37">
                        Hands-on learning spaces where students develop
                        practical...
                      </span>
                    </div>
                    <div className="home-component43">
                      <span className="home-text38">Learn more</span>
                    </div>
                  </div>
                  <div className="home-frame137">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-4fax-200h.png"
                      className="home-rectangle33"
                    />
                    <div className="home-frame1343">
                      <span className="home-text39">
                        Community Learning Hubs
                      </span>
                      <span className="home-text40">
                        Physical spaces within underserved communities...
                      </span>
                    </div>
                    <div className="home-component44">
                      <span className="home-text41">Learn more</span>
                    </div>
                  </div>
                  <div className="home-frame136">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-blzb-200h.png"
                      className="home-rectangle34"
                    />
                    <div className="home-frame1344">
                      <span className="home-text42">
                        Leadership Development
                      </span>
                      <span className="home-text43">
                        Beyond academics and technical skills, we invest in
                        cultivating...
                      </span>
                    </div>
                    <div className="home-component45">
                      <span className="home-text44">Learn more</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-frame173">
                <div className="home-frame1321">
                  <span className="home-text45">Our Reach</span>
                  <span className="home-text46">
                    Every program, every course, every mentoring session is
                    designed with one goal: transforming lives. FutureHeirs is
                    committed to measurable impact that extends beyond the
                    classroom into families, communities, and future
                    generations.
                  </span>
                </div>
                <div className="home-frame172">
                  <div className="home-frame158">
                    <img
                      alt="Rectangle41422"
                      src="/external/rectangle41422-uzab.svg"
                      className="home-rectangle43"
                    />
                    <div className="home-frame157">
                      <div className="home-frame1561">
                        <span className="home-text47">3k+</span>
                        <span className="home-text48">
                          <span>Scholarships</span>
                          <br></br>
                          <span>Awarded</span>
                        </span>
                      </div>
                      <div className="home-frame1562">
                        <span className="home-text52">200+</span>
                        <span className="home-text53">
                          <span>Enrolment</span>
                          <br></br>
                          <span>Programs</span>
                        </span>
                      </div>
                      <div className="home-group124">
                        <div className="home-group120">
                          <img
                            alt="Ellipse61422"
                            src="/external/ellipse61422-we9-200h.png"
                            className="home-ellipse61"
                          />
                          <img
                            alt="Ellipse71422"
                            src="/external/ellipse71422-pc64-200h.png"
                            className="home-ellipse7"
                          />
                        </div>
                        <div className="home-group121">
                          <div className="home-frame1563">
                            <span className="home-text57">5k+</span>
                            <span className="home-text58">
                              <span>Students</span>
                              <br></br>
                              <span>Empowered</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="home-hometestimonials">
                    <div className="home-frame146">
                      <div className="home-frame1345">
                        <div className="home-frame153">
                          <div className="home-frame1591">
                            <img
                              alt="Ellipse5I258"
                              src="/external/ellipse5i258-aorl-200w.png"
                              className="home-ellipse5"
                            />
                            <div className="home-frame1521">
                              <span className="home-text62">Michael</span>
                              <span className="home-text63">
                                Program Graduate
                              </span>
                            </div>
                          </div>
                          <div className="home-vuesaxboldquotedown1">
                            <div className="home-vuesaxboldquotedown2">
                              <div className="home-quotedown1">
                                <img
                                  alt="VectorI258"
                                  src="/external/vectori258-98ue.svg"
                                  className="home-vector14"
                                />
                                <img
                                  alt="VectorI258"
                                  src="/external/vectori258-ai8h.svg"
                                  className="home-vector15"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <span className="home-text64">
                          FutureHeirs didn&apos;t just teach me coding—they
                          showed me how to use my skills to serve others. Now
                          I&apos;m building apps that help my community access
                          resources they need.
                        </span>
                      </div>
                      <div className="home-frame148">
                        <div className="home-frame1541">
                          <div className="home-frame1592">
                            <img
                              alt="Ellipse6I258"
                              src="/external/ellipse6i258-1f9-200w.png"
                              className="home-ellipse62"
                            />
                            <div className="home-frame1522">
                              <span className="home-text65">Sarah</span>
                              <span className="home-text66">
                                Scholarship Recipient
                              </span>
                            </div>
                          </div>
                          <div className="home-vuesaxboldquotedown3">
                            <div className="home-vuesaxboldquotedown4">
                              <div className="home-quotedown2">
                                <img
                                  alt="VectorI258"
                                  src="/external/vectori258-p1qr.svg"
                                  className="home-vector16"
                                />
                                <img
                                  alt="VectorI258"
                                  src="/external/vectori258-g0s.svg"
                                  className="home-vector17"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <span className="home-text67">
                          The mentors at FutureHeirs helped me see how my faith
                          and my passion for science could work together.
                          I&apos;m now studying biomedical engineering with a
                          vision to bring healthcare solutions to underserved
                          areas.
                        </span>
                      </div>
                      <div className="home-frame151">
                        <div className="home-frame1542">
                          <div className="home-frame1593">
                            <img
                              alt="Ellipse6I258"
                              src="/external/ellipse6i258-usfi-200w.png"
                              className="home-ellipse63"
                            />
                            <div className="home-frame1523">
                              <span className="home-text68">Gabriel</span>
                              <span className="home-text69">
                                Program Graduate
                              </span>
                            </div>
                          </div>
                          <div className="home-vuesaxboldquotedown5">
                            <div className="home-vuesaxboldquotedown6">
                              <div className="home-quotedown3"></div>
                            </div>
                          </div>
                        </div>
                        <span className="home-text70">
                          FutureHeirs didn&apos;t just teach me coding—they
                          showed me how to use my skills to serve others. Now
                          I&apos;m building apps that help my community access
                          resources they need.
                        </span>
                      </div>
                    </div>
                    <img
                      alt="Rectangle6I258"
                      src="/external/rectangle6i258-m8f8-300w.png"
                      className="home-rectangle6"
                    />
                    <img
                      alt="Frame109I258"
                      src="/external/frame109i258-rxnh.svg"
                      className="home-frame1092"
                    />
                    <div className="home-component46">
                      <span className="home-text71">View more</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-frame181">
                <div className="home-frame1322">
                  <span className="home-text72">Join the Mission</span>
                  <span className="home-text73">
                    Partner, volunteer, or donate to empower the next
                    generation.
                  </span>
                </div>
                <div className="home-frame1801">
                  <div className="home-frame1771">
                    <img
                      alt="Rectangle91422"
                      src="/external/rectangle91422-tbh-300h.png"
                      className="home-rectangle91"
                    />
                    <div className="home-frame1761">
                      <div className="home-frame1741">
                        <span className="home-text74">Partner With Us</span>
                        <span className="home-text75">
                          Join hands with FutureHeirs to expand our impact.
                          Whether you&apos;re a school, faith community, or
                          organization, we can accomplish more together than
                          apart. Your partnership helps us reach more children
                          with life-changing educational opportunities.
                        </span>
                      </div>
                      <div className="home-component12">
                        <span className="home-text76">Become a Partner</span>
                      </div>
                    </div>
                  </div>
                  <div className="home-frame178">
                    <div className="home-frame1762">
                      <div className="home-frame1742">
                        <span className="home-text77">Volunteer</span>
                        <span className="home-text78">
                          Share your expertise, time, and heart. From teaching
                          classes to mentoring students, your skills can help
                          shape the next generation of leaders. Every volunteer
                          makes a difference in our mission to empower future
                          heirs.
                        </span>
                      </div>
                      <div className="home-component13">
                        <span className="home-text79">Sign Up to Voluteer</span>
                      </div>
                    </div>
                    <img
                      alt="Rectangle91422"
                      src="/external/rectangle91422-33h-300h.png"
                      className="home-rectangle92"
                    />
                  </div>
                  <div className="home-frame179">
                    <img
                      alt="Rectangle91422"
                      src="/external/rectangle91422-xy9-300h.png"
                      className="home-rectangle93"
                    />
                    <div className="home-frame1763">
                      <div className="home-frame1743">
                        <span className="home-text80">Donate</span>
                        <span className="home-text81">
                          Your financial support directly funds scholarships,
                          technology resources, and learning centers. Every
                          contribution, regardless of size, helps us equip more
                          children with the education, values, and skills they
                          need to transform their futures.
                        </span>
                      </div>
                      <div className="home-component14">
                        <span className="home-text82">Make a Donation</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-frame22">
                <div className="home-group392">
                  <img
                    alt="Rectangle11422"
                    src="/external/rectangle11422-jxft-1100w.png"
                    className="home-rectangle1"
                  />
                  <div className="home-grid">
                    <div className="home-group34">
                      <img
                        alt="Line511422"
                        src="/external/line511422-9rex3.svg"
                        className="home-line51"
                      />
                      <img
                        alt="Line521422"
                        src="/external/line521422-e6wl.svg"
                        className="home-line52"
                      />
                      <img
                        alt="Line531422"
                        src="/external/line531422-e82g.svg"
                        className="home-line53"
                      />
                      <img
                        alt="Line541422"
                        src="/external/line541422-b529.svg"
                        className="home-line54"
                      />
                      <img
                        alt="Line551422"
                        src="/external/line551422-2cd.svg"
                        className="home-line55"
                      />
                      <img
                        alt="Line561422"
                        src="/external/line561422-tsdf.svg"
                        className="home-line56"
                      />
                      <img
                        alt="Line571422"
                        src="/external/line571422-6iw.svg"
                        className="home-line57"
                      />
                    </div>
                    <div className="home-group33">
                      <img
                        alt="Line361422"
                        src="/external/line361422-cpe.svg"
                        className="home-line36"
                      />
                      <img
                        alt="Line371422"
                        src="/external/line371422-vj4o.svg"
                        className="home-line37"
                      />
                      <img
                        alt="Line381422"
                        src="/external/line381422-ccqi.svg"
                        className="home-line38"
                      />
                      <img
                        alt="Line391422"
                        src="/external/line391422-wvvf.svg"
                        className="home-line39"
                      />
                    </div>
                  </div>
                  <img
                    alt="childrenelectronicdevicesgadgetsconceptsmartconfid1422"
                    src="/external/childrenelectronicdevicesgadgetsconceptsmartconfid1422-xl627-500h.png"
                    className="home-childrenelectronicdevicesgadgetsconceptsmartconfid"
                  />
                </div>
                <div className="home-frame12">
                  <div className="home-frame1311">
                    <span className="home-text83">
                      Subscribe to our Newsletter
                    </span>
                    <span className="home-text84">
                      Join our community of supporters and stay updated on how
                      we&apos;re empowering the next generation of leaders.
                    </span>
                  </div>
                  <div className="home-cta2">
                    <div className="home-frame32">
                      <span className="home-text85">example@gmail.com</span>
                    </div>
                    <div className="home-component47">
                      <span className="home-text86">Subscribe</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="home-frame190">
            <div className="home-frame184">
              <div className="home-group107">
                <span className="home-text87">Company</span>
                <div className="home-frame2491">
                  <span className="home-text88">Home</span>
                  <span className="home-text89">About Us</span>
                  <span className="home-text90">Contact Us</span>
                  <span className="home-text91">Programs</span>
                  <span className="home-text92">Approach</span>
                </div>
              </div>
              <div className="home-group106">
                <span className="home-text93">Quick Links</span>
                <div className="home-frame2492">
                  <span className="home-text94">Partner with Us</span>
                  <span className="home-text95">Volunteer</span>
                  <span className="home-text96">Donate</span>
                  <span className="home-text97">Blog</span>
                </div>
              </div>
              <div className="home-group105">
                <span className="home-text98">Terms and Policies</span>
                <div className="home-frame248">
                  <span className="home-text99">Privacy Policy</span>
                  <span className="home-text100">Terms and Conditions</span>
                  <span className="home-text101">Feedback</span>
                  <span className="home-text102">FAQs</span>
                </div>
              </div>
              <div className="home-group104">
                <span className="home-text103">Contact Information</span>
                <div className="home-group87">
                  <span className="home-text104">connect@futureheirs.org</span>
                  <div className="home-vuesaxboldsms1">
                    <div className="home-vuesaxboldsms2">
                      <div className="home-sms">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-mb0j.svg"
                          className="home-vector18"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="home-group88">
                  <span className="home-text105">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="home-vuesaxboldlocation1">
                    <div className="home-vuesaxboldlocation2">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-g925.svg"
                        className="home-vector19"
                      />
                    </div>
                  </div>
                </div>
                <div className="home-group89">
                  <span className="home-text106">(555) 123-4567</span>
                  <div className="home-vuesaxboldcall1">
                    <div className="home-vuesaxboldcall2">
                      <div className="home-call">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-rp4.svg"
                          className="home-vector20"
                        />
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-pg2.svg"
                          className="home-vector21"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I208"
              src="/external/line2i208-l108.svg"
              className="home-line2"
            />
            <div className="home-frame183">
              <div className="home-frame161">
                <img
                  alt="VectorI208"
                  src="/external/vectori208-7r4.svg"
                  className="home-vector22"
                />
                <span className="home-text107">futureheirs</span>
              </div>
              <div className="home-frame1802">
                <span className="home-text108">Follow Us:</span>
                <div className="home-frame1772">
                  <div className="home-vuesaxboldfacebook1">
                    <div className="home-vuesaxboldfacebook2">
                      <div className="home-facebook">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-lb3d.svg"
                          className="home-vector23"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI208"
                    src="/external/riinstagramfilli208-fagi.svg"
                    className="home-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI208"
                    src="/external/pajamaslinkedini208-y7u.svg"
                    className="home-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI208"
                    src="/external/fa6brandssquarextwitteri208-es1o.svg"
                    className="home-fa6brandssquarextwitter"
                  />
                  <div className="home-vuesaxboldyoutube1">
                    <div className="home-vuesaxboldyoutube2">
                      <div className="home-youtube">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-mnli.svg"
                          className="home-vector24"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
